export interface DataType {
  id: string;
  name: string;
  description: string;
  input: string;
  output: string;
  path: string;
}

export const DATA_TYPES: DataType[] = [
  {
    id: "tar-extraction",
    name: "TAR data extraction",
    description:
      "Extract TAR data from International TDW for CRA audit submission.",
    input: "Entity code, tax type, date range",
    output: "TAR transactional (75 attributes), CSV exports",
    path: "/data-insights/tar-extraction",
  },
];
